// extracted by mini-css-extract-plugin
export default {"phaseTooltipName":"PhaseItemTooltip-module__phaseTooltipName___bBIre"};